<template>
  <!-- :close-on-click-modal="true" -->
  <!-- v-model="watch_data" -->
  <el-dialog
    :visible.sync="watch_data"
    :show-close="false"
    width="320px"
    top="0"
    class="projects-list-dialog"
    ref="AddRenameProjectAddUser"
    @close="close"
  >
    <template #title>
      <span class="el-dialog__title" v-html="$t('chat.linked_list.popup_title')"></span>
    </template>
    <div class="projects-list-popup scroll-bar-2">
      <!-- <div class="project_list-bg" @click="close"></div> -->
      <div class="projects projects--on-chat">
        <ul class="projects-list-popup__lists-wrapper">
          <li v-for="project in getSortedLists.all.filter(e => e.author == getUserData._id)" :key="project._id">
            <div
              @click="(e) => checkProject(project, e)"
              class="project-item"
              v-if="project._id != getUserData.shortcut_inbox"
              style="display: flex;"
            >
              <ShortcutsIcon></ShortcutsIcon>
              <div class="project_name_body no_messages" :data-id="project._id" style="width: calc(100% - 33px);">
                <div class="project_name" style="width: 100%;">
                  <p>
                    {{ project.name }}
                  </p>
                  <!-- <p class="last_comment_in_project__user_name num_task">
                    {{ getNumberOfTasks[project._id] ? getNumberOfTasks[project._id] : 'No' }} tasks
                  </p> -->
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
        <!-- <div class="project_list__bottom">
            <button @click="close">Cancel</button>
            <button @click="save">Save</button>
        </div> -->
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ShortcutsIcon from "../projects/ShortcutsIcon.vue";

import { EventEmitter } from "../../main";

export default {
  props: {
    chat_id: [String],
    project_id: [String],
    chat_users: [Array],
  },
  data() {
    return {
      list_id: "",
      watch_data: false,
    };
  },
  computed: {
    ...mapGetters([
      "getProjects",
      "getChats",
      "getUserData",
      "getKnownUsers",
      "getUsersByProject",
      "getUsersByChat",
      "getLists",
      "getNumberOfTasks",
      "getSortedLists"
    ]),
  },
  sockets: {
    OUT_CheckUserPlan(data) {

      if (data.no_valid) {
        let users = "";

        data.no_valid.forEach((a) => {
          let user = this.getKnownUsers.filter((e) => e._id == a);
          users += `<li>${user[0].email}</li>`;
        });

        let data = {
          data: {
            text: this.$t('app.alert.no_valid') + `
              <ul>${users}</ul>
            `,
            cancel: this.$t('app.alert.cancel'),
            delete: "",
          },
        };

        EventEmitter.$emit("OpenPopup", data);
      }
    },
  },
  mounted() {
    // localStorage.setItem('project_id', this.project_id)
    this.list_id = this.project_id;
    EventEmitter.$on("openProjectsList", () => {
      this.watch_data = true
    })
  },
  methods: {
    ...mapMutations(["setAddListsChats"]),
    ...mapActions(["socket_add_user_to_project"]),
    close() {
      this.watch_data = false;
      EventEmitter.$emit("closeProjectLists", true);
    },
    addAllNonMembers(users, id) {
      this.list_id = id;
      this.socket_add_user_to_project({
        users,
        project_id: this.list_id,
        teams: [],
      });
      this.$socket.emit(
        "IN_AddListsChats",
        this.list_id,
        this.$route.params.chat_id
      );

      setTimeout(() => {
         this.close()
      }, 100);
    },
    checkProject(project, e) {
      e.preventDefault();
      const id = project._id;


      if (id == this.list_id) {
        this.list_id = "";
      } else {

        const chatUsers = this.getChats.find(
          (chat) => chat._id == this.$route.params.chat_id
        ).users;
        const listUsers = this.getProjects.find(
          (list) => list._id == id
        ).users;

        const chatUsersEmails = {};
        const listUsersEmails = {};
        for (let i = 0; i < chatUsers.length; i++) {
          chatUsersEmails[chatUsers[i].user_data.email] =
            chatUsers[i].user_data._id;
        }

        for (let i = 0; i < listUsers.length; i++) {
          listUsersEmails[listUsers[i].email] = listUsers[i]._id;
        }

        let nonMembers = [];
        for (let email in chatUsersEmails) {
          if (email in listUsersEmails) continue;

          nonMembers.push({ email, _id: chatUsersEmails[email] });
        }

        if (nonMembers.length == 0) {
          this.list_id = id
          this.$socket.emit(
            "IN_AddListsChats",
            this.list_id,
            this.$route.params.chat_id
          );
          setTimeout(() => {
            this.watch_data = false;
          }, 100);
        } else {
          let data = {
            type: "addNonMemberUsers",
            data: {
              text: this.$t('chat.linked_list.auto_added_users'),
              cancel: this.$t('app.alert.cancel'),
              accept: this.$t('app.alert.proceed'),
              class: {
                cancel: 'red',
                accept: 'blue'
              },
              action: this.addAllNonMembers.bind(this, nonMembers, id),
            },
            list: this.task_id,
          };
          EventEmitter.$emit("OpenPopup", data);
        }


      }
    },
  },
  watch: {
    project_id(newVal) {
      this.list_id = newVal
    }
  },
  components: {
    ShortcutsIcon
  }
};
</script>
